import React from 'react';
import Svg from 'react-inlinesvg';
import { Button, Modal, Typography } from 'ui-kit';
import './WalkthroughIntroModal.scss';

const BASE_CLASS = 'WalkthroughIntroModal';
const STARS_ICON = `${process.env.PUBLIC_URL}/intro/stars.svg`;

interface Props {
  open: boolean;
  onStart: () => void;
}

export default function WalkthroughIntroModal({ open, onStart }: Props) {
  return (
    <Modal
      visible={open}
      className={BASE_CLASS}
      width={480}
      footer={null}
      // Starting the tour is the only way out, so every dismissal route stays shut
      closable={false}
      maskClosable={false}
      keyboard={false}
    >
      <span className={`${BASE_CLASS}-icon`} aria-hidden="true">
        <Svg src={STARS_ICON} />
      </span>
      <Typography variant="h5" className={`${BASE_CLASS}-title`}>
        This is your first high-earning storefront
      </Typography>
      <p className={`${BASE_CLASS}-body`}>
        Your store comes pre-loaded with best-selling items and a welcome guide to help you succeed.
      </p>
      <Button variant="contained" className={`${BASE_CLASS}-cta`} onClick={onStart}>
        Let’s take a look around
      </Button>
    </Modal>
  );
}
